import React from "react";
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
} from "recharts";

// Generates N perceptually distinct colors using the golden-ratio HSL method.
// Hue steps by ~137.5° (golden angle) so consecutive colors are maximally apart.
// Saturation and lightness alternate across 3 bands to further distinguish nearby hues.
function generateDistinctColors(n) {
    const colors = [];
    const goldenAngle = 137.508;
    const bands = [
        { s: 70, l: 45 },
        { s: 55, l: 60 },
        { s: 85, l: 35 },
    ];
    for (let i = 0; i < n; i++) {
        const hue = (i * goldenAngle) % 360;
        const { s, l } = bands[i % bands.length];
        colors.push(`hsl(${hue.toFixed(1)}, ${s}%, ${l}%)`);
    }
    return colors;
}

function RevenueChart({ chartData, chartCompanies }) {
    if (!chartData || chartData.length === 0) return null;

    const COLORS = generateDistinctColors(Math.max(chartCompanies.length, 1));

    return (
        <div className="card mt-20 mb-20 p-20">
            <h5 className="mb-15">Daily Revenue Breakdown</h5>
            <ResponsiveContainer width="100%" height={350}>
                <LineChart data={chartData} margin={{ top: 5, right: 20, left: 20, bottom: 5 }}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="date"/>
                    <YAxis width={100} tickFormatter={(v) => "₦" + v.toLocaleString()} />
                    <Legend />
                    <Tooltip
                        formatter={(value) => "₦" + Number(value).toLocaleString()}
                        contentStyle={{
                            backgroundColor: "#fff",
                            border: "1px solid #e0e0e0",
                            borderRadius: "6px",
                            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                        }}
                        labelStyle={{ fontWeight: "600", marginBottom: "4px" }}
                        wrapperStyle={{ zIndex: 1000 }}
                    />
                    {chartCompanies.map((company, index) => (
                        <Line
                            key={company}
                            type="monotone"
                            dataKey={company}
                            name={company}
                            stroke={COLORS[index]}
                            dot={false}
                            activeDot={{ r: 5 }}
                        />
                    ))}
                </LineChart>
            </ResponsiveContainer>
        </div>
    );
}

export default RevenueChart;
